interface SiteFooterProps {
  className?: string
}

export default function SiteFooter({ className = '' }: SiteFooterProps) {
  return (
    <footer
      className={`shrink-0 border-t border-[var(--border-color)] bg-[var(--bg-secondary)] px-4 py-2.5 text-center text-[11px] text-[var(--text-tertiary)] sm:text-xs ${className}`}
    >
      ©{' '}
      <a
        href="https://reactplus.com/"
        target="_blank"
        rel="noopener noreferrer"
        className="font-medium text-[var(--accent)] underline-offset-2 transition-colors hover:text-[var(--accent-hover)] hover:underline focus-visible:rounded-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--ring)]"
      >
        React Plus
      </a>
      , JSC 2021. All rights reserved
    </footer>
  )
}
